import '../../../../styles/invoice.css';

import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

// Material
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import {
  getEmployees,
  setEmployeeFilter,
} from '../../../../actions/employeeActions';
import ListWithFilter from '../../../../components/list/listWithFilter.component';
import ResponseModal from '../../../../components/modal/responseModal.component';
import CustomProgress from '../../../../components/Progress/progress.component';
// custom hooks
import { useEmployees } from '../../../../hooks/useEmployees';
import { useRegisterEmployee } from '../../../../hooks/useRegisterEmployee';
import { useWindowSize } from '../../../../hooks/useResizeWindows';
import DATA_NOT_FOUND_IMAGE from '../../../../images/NotificacionesColfactura.png';
import { TypesTabEmployee } from '../../../../types/TypesTabEmployee.js';
import Buttons from '../components/actionButtons';
// Components
import Detail from '../components/detail';

const useStyles = makeStyles(theme => ({
  txtFilter: {
    margin: '10px 0px 10px 0px',
    color: theme.palette.primaryColor,
  },
  datanotfound: {
    display: 'block',
    marginTop: '5%',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    textAlign: 'center',
  },
  datanotfoundText: {
    color: theme.palette.primaryColor,
    fontSize: '30px',
    fontWeight: '400',
    fontFamily: 'Muli',
  },
}));

const Actives = ({ setContentTab, setBulkLoad, updateEmployee }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [employeeIdSelected, setEmployeeIdSelected] = useState(null);
  const [heightList, setHeightList] = useState(0);
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const filterEmployee = useSelector(s => s.employeeReducer.filterEmployee);
  const {
    employeeDetail,
    fillEmployeeById,
    listFilterEmployeeActives,
    changeStateFavorite,
    changeEditingStatus,
    changeOpenRegisterEmployee,
    retireEmployee,
    loadingGetEmployees,
    loadingDetailEmployee,
    filteredList,
  } = useEmployees();

  const { height } = useWindowSize();
  const { responseCreateProcess, saveResponseCreate, setReintegreStatus } =
    useRegisterEmployee();

  useEffect(() => {
    if (
      responseCreateProcess &&
      responseCreateProcess.statusCode &&
      (responseCreateProcess.statusCode === '200' ||
        responseCreateProcess.statusCode === '201')
    ) {
      setOpenCreateModal(true);
    } else {
      setOpenCreateModal(false);
    }
  }, [responseCreateProcess]);

  /**
   * Consulta Información de primer empleado en la lista
   */
  useEffect(() => {
    if (filteredList?.length > 0) {
      const id = filteredList[0].id;
      fillEmployeeById(id);
      setEmployeeIdSelected(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredList]);

  /**
   * Consulta lista de empleados al completar cargue masivo cambiando el estate de updateEmployee
   */
  useEffect(() => {
    if (updateEmployee) {
      dispatch(getEmployees());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEmployee]);

  /**
   * Lee altura de pantalla
   */
  useEffect(() => {
    const windowsHeight = height ?? 0;
    const discount = windowsHeight * 0.19;
    setHeightList(windowsHeight - discount);
  }, [height]);

  /**
   * Limpia filtro de empleados al salir de la vista
   */
  useEffect(() => {
    return () => {
      dispatch(
        setEmployeeFilter({
          ...filterEmployee,
          contractToFinish: false,
        }),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  /**
   * Escucha evento selección de empleado
   * @param {*} item
   */
  const handleEmployeeSelection = item => {
    fillEmployeeById(item.id);
    setEmployeeIdSelected(item.id);
  };

  /**
   * ??
   */
  const closeSuccessModal = () => {
    saveResponseCreate(null);
  };

  /**
   * Abre formulario para edición de empleado e modo reintegro
   */
  const handleReintegrate = () => {
    setReintegreStatus(true);
    changeOpenRegisterEmployee();
    changeEditingStatus(true);
  };

  return (
    <>
      {loadingGetEmployees ? (
        <div style={{ paddingTop: 40 }}>
          <CustomProgress />
        </div>
      ) : (
        <Grid container>
          {listFilterEmployeeActives?.length > 0 ? (
            <>
              <Grid item lg={5} md={6} sm style={{ marginTop: 7 }}>
                {!loadingGetEmployees ? (
                  <>
                    <ListWithFilter
                      list={filteredList}
                      textSearch="Buscar empleado por nombre o documento"
                      onClick={item => {
                        handleEmployeeSelection(item);
                      }}
                      selectedId={employeeIdSelected}
                      maxHeight={heightList}
                    />
                  </>
                ) : (
                  <div style={{ paddingTop: 20 }}>
                    <CustomProgress />
                  </div>
                )}
              </Grid>
              <Grid item lg={7} md={6} sm style={{ paddingLeft: '1%' }}>
                <Buttons setBulkLoad={setBulkLoad} />
                {!loadingDetailEmployee &&
                employeeIdSelected === employeeDetail?.id ? ( //Debe ser loadingDetail
                  <>
                    <Detail
                      setContentTab={setContentTab}
                      employeeDetail={employeeDetail}
                      type={TypesTabEmployee.Activos}
                      changeStateFavorite={changeStateFavorite}
                      loadingSpinner={loadingGetEmployees}
                      changeEditingStatus={changeEditingStatus}
                      changeOpenRegisterEmployee={changeOpenRegisterEmployee}
                      retireEmployee={retireEmployee}
                      handleReintegrate={handleReintegrate}
                    />
                  </>
                ) : (
                  <div style={{ paddingTop: 20 }}>
                    <CustomProgress />
                  </div>
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item lg={5} md={6} sm></Grid>
              <Grid item lg={7} md={6} sm>
                <Buttons setBulkLoad={setBulkLoad} />
              </Grid>
              <Grid container>
                <Grid item lg={12} xs={12} className={classes.datanotfound}>
                  <img src={DATA_NOT_FOUND_IMAGE} alt="Datos no encontrados" />
                  <div className={classes.datanotfoundText}>
                    No tienes Empleados creados
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      )}

      <ResponseModal
        modalType="success"
        title="Que buena onda!!!"
        subtitle="Creaste un nuevo empleado"
        body="¡Es bueno tener talento nuevo, sigue así!"
        modalImage="successEmployee"
        open={openCreateModal}
        closeElement="Skip"
        onCloseElement={() => closeSuccessModal()}
      />
    </>
  );
};

export default Actives;
